/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const recruiterAvailabilityResponseSchema = z.object({
	bufferMinutes: z.number(),
	maxBookingsPerDay: z.number(),
	minAdvanceNoticeHours: z.number().nullable(),
	timezone: z.string(),
	schedule: z.object({
		slots: z.array(z.object({ day: z.number(), start: z.string(), end: z.string() })),
		overrides: z.array(
			z.object({
				from: z.string(),
				to: z.string(),
				open: z.boolean(),
				start: z.string().nullable(),
				end: z.string().nullable(),
			}),
		),
	}),
})

export type RecruiterAvailabilityResponseSchema = z.infer<typeof recruiterAvailabilityResponseSchema>
